module.exports = __webpack_public_path__ + "media/yi6.17bd01b8.mp4";